import { Component, inject } from '@angular/core';
import {
  ToastItem,
  ToastNotificationService,
} from '../../core/toast-notification.service';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [],
  templateUrl: './toast-container.component.html',
  styleUrl: './toast-container.component.scss',
})
export class ToastContainerComponent {
  readonly toastService = inject(ToastNotificationService);

  get toasts(): ToastItem[] {
    return this.toastService.toasts();
  }

  onToastClick(toast: ToastItem): void {
    void this.toastService.onToastClick(toast);
  }

  onDismiss(event: MouseEvent, id: string): void {
    event.stopPropagation();
    this.toastService.dismiss(id);
  }

  onMouseEnter(id: string): void {
    this.toastService.pause(id);
  }

  onMouseLeave(id: string): void {
    this.toastService.resume(id);
  }
}
